import React from "react";
import { MessageCircle, Send } from "lucide-react";
import { useSite } from "../context/SiteContext";

export default function FloatingButtons() {
  const { site } = useSite();
  return (
    <div className="fixed bottom-5 right-4 sm:right-6 z-50 flex flex-col gap-3">
      <a href={site.telegramUrl} target="_blank" rel="noreferrer" aria-label="Telegram" className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#229ED9] hover:bg-[#1f8fc4] flex items-center justify-center shadow-lg shadow-sky-900/40 transition-transform hover:scale-105">
        <Send className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
      </a>
      <a href={site.whatsappUrl} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#1fb557] flex items-center justify-center shadow-lg shadow-green-900/40 transition-transform hover:scale-105">
        <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
      </a>
    </div>
  );
}
